import { LatLng, LatLngBounds } from 'leaflet';
import { useCallback, useEffect, useMemo } from 'react';
import { AONB_Bounds } from '../../application/config';
import { useMap } from 'react-leaflet';
import { Trail } from '../../models/Trail';
import { getTrailPathLatLngs } from './mapPointUtils';

type MapControllerProps = {
	trail: Trail;
};

const cloneAONBBounds = () =>
	new LatLngBounds(AONB_Bounds.getSouthWest(), AONB_Bounds.getNorthEast());

const calcBoundary = (pointList: LatLng[]) => {
	if (pointList.length === 0) {
		return cloneAONBBounds();
	}
	if (pointList.length === 1) {
		const boundary = cloneAONBBounds();
		boundary.extend(pointList[0]);
		return boundary;
	}
	const boundary = new LatLngBounds(pointList[0], pointList[1]);
	for (let listNdx = 2; listNdx < pointList.length; listNdx++) {
		boundary.extend(pointList[listNdx]);
	}
	return boundary;
};

export default function SingleTrailNavigatorController({
	trail,
}: MapControllerProps) {
	const map = useMap();
	const trailPath = useMemo(() => getTrailPathLatLngs(trail), [trail]);

	const handleBoundsTicker = useCallback(() => {
		try {
			const boundary = calcBoundary(trailPath);
			const current_center = map.getBounds().getCenter();
			const required_center = boundary.getCenter();

			if (boundary.isValid()) {
				map.fitBounds(boundary);
			}
			if (required_center.distanceTo(current_center) > 1000) {
				setTimeout(handleBoundsTicker, 500);
			}
		} catch (e) {
			/* ignore fit failures */
		}
	}, [map, trailPath]);

	useEffect(() => {
		handleBoundsTicker();
	}, [handleBoundsTicker]);

	return null;
}
